import modal from '../module/global/modal';

export default class entranceManager {
    constructor(effect) {

        this.effect = effect;

        this.modal = new modal();

        //object
        this.$body = document.getElementsByTagName('body');
        this.$root = document.getElementById("l-root");
        this.$kv = document.getElementById('p-kv');
            this.$scroll = document.getElementById("c-scroll");
        this.$header = document.getElementById('l-header');

        //enttance object
        this.$entrance = document.getElementById("p-entrans");
        this.$bgTarget = document.querySelectorAll("#p-entrans-bg .bg");
        this.$logo = document.getElementById("p-entrans-cont-logo");
        this.$copy = document.getElementById("p-entrans-cont-copy");

        //status
        this.status = {
            loading : false,
            w : 0,
        }

    }
    init(scroll,mouse){

        /*---------------------------------

         splash

        ---------------------------------*/

        this.effect.scale(document.querySelectorAll(".js__sp-scale"),"set");
        this.effect.showSimple([this.$logo,this.$copy],"set");
        this.effect.svg(document.querySelector("#p-entrans-copy-dog .type-text"),"set");
        this.effect.svg(document.querySelector("#p-entrans-copy-cat .type-text"),"set");

        TweenMax.set([document.querySelector("#p-entrans-copy-dog .for"),document.querySelector("#p-entrans-copy-cat .for")],{
            x : -100 + "%"
        })
        TweenMax.set([document.querySelector("#p-entrans-copy-dog .for svg"),document.querySelector("#p-entrans-copy-cat .for svg")],{
            x : 100 + "%"
        })

        TweenMax.set([this.$kv,document.getElementById("p-top-about")],{
            opacity : 0
        })
        TweenMax.set(this.$entrance,{
            display : 'block'
        })
        TweenMax.set([this.$scroll,this.$header],{
            display : 'none'
        })
        this.modal.init(scroll,mouse);

        setTimeout(()=>{
            this.effect.scale(document.querySelectorAll(".js__sp-scale"),"show");
            this.effect.panel(document.querySelectorAll(".js__sp-image-mask"),"show");
            setTimeout(()=>{
                this.effect.showSimple([this.$logo,this.$copy],"show");
                this.effect.svg(document.querySelector("#p-entrans-copy-dog .type-text"),"show");
                this.effect.svg(document.querySelector("#p-entrans-copy-cat .type-text"),"show");
                setTimeout(()=>{
                    TweenMax.to([document.querySelector("#p-entrans-copy-dog .for"),document.querySelector("#p-entrans-copy-cat .for"),document.querySelector("#p-entrans-copy-dog .for svg"),document.querySelector("#p-entrans-copy-cat .for svg")],0.4,{
                        x : 0 + "%"
                    })
                    mouse.modeChange('small','scroll');
                    this.status.loading = true;
                },1e3)
            },1e3)
        },12e2)

        /*---------------------------------

         mouseover event

        ---------------------------------*/

        // this.$target = document.querySelectorAll("#p-entrans-bg .bg");

        // for(let i in this.$target){
        //
        //     if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める
        //
        //     this.$target[i].addEventListener("mouseenter",(e)=>{
        //         if(this.status.loading){
        //             this.mouseEnter(e.target);
        //         }
        //     });
        //     this.$target[i].addEventListener("mouseleave",(e)=>{
        //         if(this.status.loading){
        //             this.mouseLeave(e.target);
        //         }
        //     });
        //
        // }

        /*---------------------------------

         click event

        ---------------------------------*/

        for(let i in this.$bgTarget){

            if(this.$bgTarget[i].nodeType!=1) continue; // dom要素以外は処理止める

            this.$bgTarget[i].addEventListener("click",(e)=>{
                this.pageEnter(e.target);
            });

        }


    }
    mouseEnter($t) {
        TweenMax.to($t.querySelector(".bg-img"), 10.8, {
            scale:1.18,
        })
    }
    mouseLeave($t) {
        TweenMax.to($t.querySelector(".bg-img"), 4.6, {
            scale:1,
        })
    }
    pageEnter($t){

        this.status.loading = false;

        this.effect.scale([document.getElementById("l-mousepointer")],"out");
        this.effect.showSimple([this.$logo,this.$copy],"out");
        this.effect.svg(document.querySelector("#p-entrans-copy-dog .type-text"),"out");
        this.effect.svg(document.querySelector("#p-entrans-copy-cat .type-text"),"out");
        TweenMax.to([document.querySelector("#p-entrans-copy-dog .for"),document.querySelector("#p-entrans-copy-cat .for")], 0.4 ,{
            x : -100 + "%"
        })
        TweenMax.to([document.querySelector("#p-entrans-copy-dog .for svg"),document.querySelector("#p-entrans-copy-cat .for svg")], 0.4 ,{
            x : 100 + "%"
        })
        if($t.parentNode.id === 'p-entrans-bg-dog'){ // dog
            TweenMax.to(document.querySelector("#p-entrans-bg-dog .bg-img"), 0.8, {
                scale:1.5,
                opacity:0
            })
            TweenMax.to(document.querySelector("#p-entrans-bg-cat .bg-img"), 0.6 ,{
                opacity : 0
            })
        }else{ // cat
            TweenMax.to(document.querySelector("#p-entrans-bg-cat .bg-img"), 0.8, {
                scale:1.5,
                opacity:0
            })
            TweenMax.to(document.querySelector("#p-entrans-bg-dog .bg-img"), 0.6 ,{
                opacity : 0
            })
        }

        setTimeout(()=>{
            if($t.parentNode.id === 'p-entrans-bg-dog'){ // dog
                location.href = '/pb/';
            }else{ // cat
                location.href = '/pb/cat/';
            }
        },7e2)
    }
    render(scrollInc,mouse){
        if(!this.status.loading) return;
        if(mouse.pointer.x < this.status.w/2){
            this.mouseEnter(this.$bgTarget[0]);
            this.mouseLeave(this.$bgTarget[1]);
        }else{
            this.mouseEnter(this.$bgTarget[1]);
            this.mouseLeave(this.$bgTarget[0]);
        }
    }
    resize(w,h,deviceSize){

        this.status.w = w;

        TweenMax.set([this.$body,this.$root],{
            height : h,
            overflow : 'hidden'
        })

    }
}